const namespace = 'auth'

export const SET_AUTH = `${namespace}/SET_AUTH`
export const VERIFY_2FA = `${namespace}/VERIFY_2FA`
export const RESET_AUTH = `${namespace}/RESET_AUTH`
